import { Tag } from '@phosphor-icons/react';

export default Tag;